import React from "react";
import Lottie from "lottie-react";
import CountUp from "react-countup";
import animationData from "../assets/trend-arrow.json";
import "../css/StatsSection.css";
import TaxSavingsCalculatorHomePage from "./TaxSavingsCalculatorHomePage";
import missedOpportunityImg from "../assets/Missed Opportunity.gif";
import Testimonials from "./Testimonials";

const StatsSection = () => {
  return (
    <section className="two-frame-stats">
      <div className="content-wrapper">
        <div className="stats-content-wrapper">
          <h2 className="highlight-headline">
            Missed tax savings uncovered
          </h2>
          <div className="highlight-amount">
            <CountUp
              start={0}
              end={300000}
              duration={2.5}
              separator=","
              prefix="$"
              useEasing={true}
              enableScrollSpy={true}
              scrollSpyOnce={true}
            /> +
          </div>
          <p className="highlight-subtitle">
            and that's just from our first batch of Alpha Champions
          </p>
        </div>
        <img
          className="two-frame-stats-background-img"
          src={missedOpportunityImg}
        />
      </div>
      <div className="two-frame-stats-background">
        <div className="bumper bumper-1"></div>
        <div className="bumper bumper-2"></div>
      </div>
      <Testimonials />
    </section>
  );
};

export default StatsSection;
